import { GetServerSideProps } from 'next';
import { NavBarContent } from '@/components/Navbar';
import { api, site } from '@/services/api';
import InstitutionalPage from '@/components/Institutional/InstitutionalPage';
import { FeaturedNewsApi, HeadTags } from '@/shared/types/home.types';
import { SchemaType } from '@/components/Internals/InternalSchema';
import getConcurrentPromises from '@/utils/getConcurrentPromises';
import Layout from '@/components/Layout';

interface NavBarContentData {
  data: NavBarContent;
}

export interface InstitutionalProps {
  institutionalData: {
    data: {
      cabecalho: {
        titulo: string;
        descricao: string;
        imagem: { url: string; srcset: { [key: number]: string }; blurhash: string };
      };
      conteudo: string;
    };
  };
  ssr: HeadTags[];
  navBarData: NavBarContent;
  schema: SchemaType;
}

export default function Privacy({ institutionalData, navBarData, ssr, schema }: InstitutionalProps) {
  const { data } = institutionalData;
  const { cabecalho, conteudo } = data;

  return (
    <Layout layoutData={{ segmentacoes: [], tagsData: ssr, navBarData, schema }}>
      <InstitutionalPage
        text={conteudo}
        title="Política de Privacidade"
        headerImg={{ url: cabecalho.imagem.url, blurhash: cabecalho.imagem.blurhash, srcset: cabecalho.imagem.srcset }}
        breadcrumbs={[]}
        type="privacidade"
      />
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { host } = context.req.headers;

  const mainReq = { promise: site.get<FeaturedNewsApi>(`/privacidade/`), link: `/privacidade/` };
  const responseMenuReq = { promise: api.get<NavBarContentData>(`/componentes/menu/`), link: `/componentes/menu/` };

  const { promiseData, data, statusCode } = await getConcurrentPromises({
    mainPromise: mainReq,
    navBarPromise: responseMenuReq,
    host,
  });

  if (data.redirect || data.notFound) return data;

  const navBarData: NavBarContentData = promiseData[responseMenuReq.link].data.data;
  const { ssr, headers, schema } = data;

  context.res.setHeader('Cache-Control', headers['Cache-control']);
  context.res.setHeader('Expires', headers.Expires);
  context.res.statusCode = statusCode;

  const institutionalData = data;

  return {
    props: {
      institutionalData,
      navBarData,
      ssr,
      headers,
      schema,
    },
  };
};
